import { render, staticRenderFns } from "./Mohead.vue?vue&type=template&id=20ac1db8&"
import script from "./Mohead.vue?vue&type=script&lang=js&"
export * from "./Mohead.vue?vue&type=script&lang=js&"
import style0 from "./Mohead.vue?vue&type=style&index=0&id=20ac1db8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports